import * as React from 'react'
import LineCrownIcon from 'LuxKit/Icons/line/LineCrownIcon'
import LineTaxiIcon from 'LuxKit/Icons/line/LineTaxiIcon'
import LineChairWithAirplaneIcon from 'LuxKit/Icons/line/LineChairWithAirplaneIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineCompassIcon from 'LuxKit/Icons/line/LineCompassIcon'
import LineMobileAndroidIcon from 'LuxKit/Icons/line/LineMobileAndroidIcon'

/** Display order for tier progression and Société tier-upgrade benefit lists */
export const TIER_PROGRESSION_BENEFIT_ORDER: Array<App.LoyaltyBenefitType> = [
  'hotel_upgrade',
  'lounge_pass',
  'airport_transfer',
  'discounted_insurance',
  'tour_exp_credit',
  'phone_support',
  'esim_package',
]

export const BENEFIT_ICONS: Record<App.LoyaltyBenefitType, React.ReactNode> = {
  hotel_upgrade: <LineCrownIcon size="XS" />,
  airport_transfer: <LineTaxiIcon size="XS" />,
  lounge_pass: <LineChairWithAirplaneIcon size="XS" />,
  discounted_insurance: <LineShieldCheckIcon size="XS" />,
  phone_support: <LinePhoneIcon size="XS" />,
  tour_exp_credit: <LineCompassIcon size="XS" />,
  early_access: null,
  esim_package: <LineMobileAndroidIcon size="XS" />,
  hidden_access: null,
  family_and_friends_access: null,
}
